import { Component, ElementRef, Input, OnChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ResponsiveDisplayConstants } from '@ddt-web/dom';

import { ChartDispatcher } from '../../dispatcher';
import { ChartFactory } from '../../factories/chart.factory';
import { IHighChartsAttributesModel } from '../../models';
import { IChartWorker } from '../../workers/common/chart.worker.interface';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-chart',
	templateUrl: './chart.component.html',
	styleUrls: ['./chart.component.scss'],
	encapsulation: ViewEncapsulation.None
})

/**
 * NewChartComponent: Component, where the highchart chart object is rendered upon.
 */
export class NewChartComponent implements OnChanges {
	@Input() public highChartsAttributes: IHighChartsAttributesModel;
	@ViewChild('chartContainer', { static: true }) public container: ElementRef;

	private worker: IChartWorker;

	constructor(private elementRef: ElementRef) { }

	public ngOnChanges(): void {
		this.highChartsAttributes.container = this.container;
		setTimeout(() => {
			// If a worker has been initialized and the attributes passed contain a dataUpdate
			if (this.highChartsAttributes.dataUpdate && this.worker) {
				this.worker.updateData(this.highChartsAttributes.dataUpdate);
			} else {
				const hasFullHeight = this.highChartsAttributes.customAttributes ? this.highChartsAttributes.customAttributes.hasFullHeight : false;
				if (hasFullHeight && window.innerWidth >= ResponsiveDisplayConstants.DEVICE_WIDTH.MOBILE_MAX) {
					this.highChartsAttributes.height = this.elementRef.nativeElement.offsetHeight;
					this.highChartsAttributes.width = this.elementRef.nativeElement.offsetWidth;
					this.generateChart();
				} else {
					this.generateChart();
				}
			}
		});
	}

	private generateChart(): void {
		if (this.highChartsAttributes.tabData && !this.highChartsAttributes.tabData.error) {
			const factory = new ChartFactory();
			this.worker = new ChartDispatcher(this.highChartsAttributes).createWorker();
			factory.createChart(this.worker);
		}
	}
}
